module.exports = __webpack_public_path__ + "static/reinserir-completo-787b683ddc38dcc58c691b997b1a08c3.svg";